import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDateFormat } from "../../../../hooks/useDateFormat";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/freezeLifecycleSagas";

const DatePicker = ({ isRangePicker = false }) => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.freezeLifecycle.currentUser
  );
  const { startDate, endDate } = useSelector((state) => state.freezeLifecycle.selectedFilters);

  const rangeOverrides = isRangePicker
    ? {
        disabled: false,
        startDate,
        endDate,
        updateDates: (startDate, endDate) =>
          dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    : {};

  return (
    <div className={`date-select-box ${isRangePicker ? "multi" : ""}`}>
      <p>Date</p>
      <ReactDatePicker
        disabled
        isRangePicker={isRangePicker}
        displayFormat={dateFormat}
        calendarEndDate={calendarEndDate}
        minDate={calendarStartDate}
        startDate={calendarEndDate}
        {...rangeOverrides}
      />
    </div>
  );
};

export default DatePicker;
